import lessThan from './less-than';

export default function lessThanOrEqualTo(value, options = {}) {
  return lessThan(value, { ...options, equal: true });
}

lessThanOrEqualTo.message = function message(value, options = {}) {
  return lessThan.message(value, { ...options, equal: true });
};
